<template>
    <div class="main">
        <div class="title">
            <span class="number">{{ locationIndex }}</span>
            {{ title }}
            <span></span>
            <span v-show="location.options.is_round_trip" class="round-trip">來回件</span>
        </div>
        <div v-show="address" class="address">
            {{ address }}
        </div>
        <div class="user">
            <div class="span">聯絡人</div>
            {{ user }}
        </div>
        <div class="note-padding">
            <div class="note" v-show="location.note">
                <div class="icon">
                    <img src="@/assets/img/enter.svg">
                </div>
                <div class="content">{{ location.note }}</div>
            </div>
        </div>
        <div v-show="location.snapshot && location.snapshot.length">
            <div class="products">
                <div v-for="(product, index) in location.snapshot" :key="index">
                    <div class="product">
                        <div class="product-content">
                            <div class="product-title">
                                <span>x {{ product.count }}</span>{{ product.name }}
                            </div>
                            <div class="product-info">
                                {{ product.options | OptionsToString }}
                            </div>
                        </div>
                        <div class="product-price">
                            $ {{ product.is_elastic ? '依店內價格' : product.sumPrice * product.count }}
                        </div>
                    </div>
                    <div class="product-note" v-show="product.note">
                        <div class="product-icon">
                            <img src="@/assets/img/enter.svg">
                        </div>
                        <div class="product-content">{{ product.note }}</div>
                    </div>
                </div>
            </div>
            <div class="products-price" v-if="hasElastic">
                此地點依店內價格
            </div>
            <div class="products-price" v-else>
                此地點預估費用 <span>$ {{ price }}</span>
            </div>
        </div>
        <photo-uploader :is-preview-mode="true" :is-base64="false" :opacity=".5" height="50px" :group-id="location.id" :value="location.mission_photos || []"/>
        <div class="advanced" v-show="location.options.is_self_buy || location.options.is_insulation || location.options.vat">
            <div class="advanced-item" v-show="location.options.is_self_buy">
                <img src="@/assets/img/ordered.svg">
                已訂購
            </div>
            <div class="advanced-item" v-show="location.options.is_insulation">
                <img src="@/assets/img/insulation.svg">
                需保溫
            </div>
            <div class="advanced-item" v-show="location.options.vat && location.options.vat.length">
                <img src="@/assets/img/vat.svg">
                統編 {{ location.options.vat }}
            </div>
        </div>
        <div class="status">
            <div class="item gray" v-show="!location.arrived_at">{{notYetStarted ? '尚未開始' : '尚未抵達' }}</div>
            <div class="item gray" v-show="!location.behalf_price">尚無代墊</div>
            <div class="item" v-show="time">
                花費
                <div class="content">{{ time }}</div>
            </div>
            <div class="item" v-show="location.behalf_price">
                實際代付
                <div class="content">${{ location.behalf_price }}</div>
            </div>
        </div>
        <div class="photos">
            <div class="photo" :style="arrivalPhotoStyle">
                <img v-if="location.arrival_photo" v-gallery="'location-' + location.id" :src="location.arrival_photo.url">
            </div>
            <div class="photo" :style="leavePhotoStyle">
                <img v-if="location.leave_photo" v-gallery="'location-' + location.id" :src="location.leave_photo.url">
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import PhotoUploader from "../../task/PhotoUploader";

    export default {
        name: 'LocationItem',
        components: {
            'photo-uploader': PhotoUploader,
        },
        props: {
            location: {
                required: true,
            },
            isDone: {
                default: false,
            },
            locationIndex: {
                required: true,
            },
            order: {
                required: true,
            }
        },
        computed: {
            hasElastic() {
                if (!this.location.snapshot) {
                    return 0;
                }

                return this.location.snapshot.filter(product => product.is_elastic).length;
            },
            notYetStarted() {
                if (! this.order.reserved_at) {
                    return false;
                }

                return this.locationIndex === 1 && moment().isBefore(this.order.reserved_at);
            },
            title() {
                return this.location.alias ?
                    this.location.alias :
                    this.location.district + this.location.road + ' ' + this.location.additional;
            },
            address() {
                return this.location.alias ?
                    this.location.district + this.location.road + ' ' + this.location.additional :
                    '';
            },
            user() {
                let user = '未填聯絡人';

                if (this.location.name) {
                    user = this.location.name;
                }

                if (this.location.phone) {
                    user = user + ' ' + this.location.phone;
                }

                return user;
            },
            arrivalPhotoStyle() {
                let url = require('@/assets/img/photo-default.svg');

                if (this.location.arrival_photo) {
                    url = this.location.arrival_photo.url;
                }

                return {
                    'background-image': `url(${url})`
                }
            },
            leavePhotoStyle() {
                let url = require('@/assets/img/photo-default.svg');

                if (this.location.leave_photo) {
                    url = this.location.leave_photo.url;
                }

                return {
                    'background-image': `url(${url})`
                }
            },
            price() {
                if (!this.location.snapshot) {
                    return 0;
                }

                return this.location.snapshot.filter(product => !product.is_elastic).reduce((amount, product) => amount + (product.sumPrice * product.count), 0);
            },
            time() {
                if (!this.location.arrived_at || !this.location.left_at) {
                    return '';
                }

                let arrived = moment(this.location.arrived_at);
                let left = moment(this.location.left_at);

                let seconds = left.diff(arrived, 'seconds');
                let minutes = left.diff(arrived, 'minutes');

                let diff = (seconds - (minutes * 60)) + '秒';
                if (minutes) {
                    diff = minutes + '分' + diff;
                }

                return diff;
            }
        },
        filters: {
            OptionsToString(options) {
                return options.map(option => option.name).join(', ');
            }
        }
    };
</script>

<style lang="scss" scoped>
    .main {
        padding: 10px;
        width: 100%;

        .title {
            /*display: flex;*/
            /*align-items: baseline;*/
            color: #4a4a4a;
            font-size: 16px;
            line-height: 22px;
            font-weight: 500;
            text-align: left;

            .number {
                background-color: #9b9b9b;
                width: 20px;
                height: 20px;
                border-radius: 50%;
                display: inline-block;
                /*display: flex;*/
                justify-content: center;
                align-items: center;
                color: white;
                font-size: 14px;
                line-height: 20px;
                margin-right: 5px;
                flex-shrink: 0;
                text-align: center;
            }

            .round-trip {
                float: right;
                border-radius: 10.5px;
                background-color: #4A4A4A;
                color: #FFFFFF;
                font-size: 12px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 17px;
                padding: 2px 10px;
                user-select: none;
            }
        }

        .address {
            margin-top: 10px;
            color: #4a4a4a;
            font-size: 14px;
            text-align: left;
        }

        .user {
            margin-top: 10px;
            display: flex;
            color: #4a4a4a;
            font-size: 14px;
            line-height: 20px;
            font-weight: 600;


            .span {
                font-weight: 400;
                margin-right: 5px;
            }
        }

        .note-padding {
            padding-bottom: 10px;
        }
        .note {
            display: flex;
            align-items: baseline;

            .icon {
                flex: 0;
            }

            .content {
                white-space: pre-line;
                color: #9B9B9B;
                font-size: 14px;
                letter-spacing: 0;
                line-height: 20px;
                text-align: left;
                word-break: break-all;
            }
        }

        .advanced {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: #9b9b9b;
            font-size: 14px;
            padding-top: 10px;
            border-top: 1px #DDDDDD solid;

            .advanced-item {
                display: flex;
                align-items: center;
                justify-content: center;

                &:not(:last-child) {
                    margin-right: 5px;
                }
            }
        }

        .status {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            color: #4a4a4a;
            font-size: 14px;
            padding-top: 10px;

            .item {
                padding: 5px 15px;
                border-radius: 5px;
                box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
                display: flex;

                .content {
                    color: #339933;
                    margin-left: 5px;
                }

                &:not(:last-child) {
                    margin-right: 10px;
                }

                &.gray {
                    color: #9b9b9b;
                }
            }
        }

        .photos {
            margin-top: 10px;
            display: flex;

            .photo {
                display: flex;
                flex: 1;
                height: 52px;
                background-position: 50% 50%;
                background-size: cover;
                background-repeat: no-repeat;

                &:not(:last-child) {
                    margin-right: 10px;
                }

                img {
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                    filter: alpha(opacity=0);
                }
            }
        }

        .products-price {
            border-top: 1px #DDDDDD solid;
            padding: 10px;
            text-align: center;
            color: #9b9b9b;
            font-size: 13px;
        }

        .products {
            padding: 0 10px;
            text-align: left;

            .product-note {
                display: flex;
                align-items: baseline;
                margin-left: 5px;
                padding-bottom: 10px;

                .product-icon {
                    flex: 0;
                }

                .product-content {
                    white-space: pre-line;
                    color: #9B9B9B;
                    font-size: 12px;
                    letter-spacing: 0;
                    line-height: 17px;
                    text-align: left;
                }
            }

            .product {
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-top: 1px #dddddd solid;
                padding: 10px 0;

                .product-price {
                    color: #9B9B9B;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 20px;
                }

                .product-content {
                    .product-title {
                        color: #9B9B9B;
                        font-size: 14px;
                        letter-spacing: 0;
                        line-height: 20px;
                        text-align: left;

                        span {
                            font-size: 14px;
                            letter-spacing: 0;
                            line-height: 20px;
                            margin-right: 10px;
                            color: #339933;
                            margin-left: 0;
                            padding: 0;
                        }
                    }

                    .product-info {
                        color: #9B9B9B;
                        font-size: 12px;
                        letter-spacing: 0;
                        line-height: 17px;
                        margin-top: 5px;

                        span {
                            font-size: 14px;
                            letter-spacing: 0;
                            line-height: 20px;
                            margin-right: 10px;
                        }
                    }
                }
            }
        }
    }
</style>
